export const blockIconsHardwareHeadphones = (
	<span className='material-symbols-outlined'>headphones</span>
);
